require('fancybox')($);
require('fancybox/dist/helpers/js/jquery.fancybox-media.cjs.js')($);
require('./fancybox.less');

let size = require('../../modules/size');

jQuery(function() {
    $(document).on('click', '.js-fancybox', function(e) {
        e.preventDefault();
        $.fancybox({
            padding: [29, 25, 29, 25],
            href: this.href
        });
    });

    $(document).on('click', '.js-fancybox-video', function(e) {
        e.preventDefault();
        var $this = $(this);

        var padding = [29, 25, 29, 25];
        if (window.innerWidth < size.tablet) padding = [10, 10, 10, 10];

        $.fancybox({
            openEffect: 'none',
            closeEffect: 'none',
            padding: padding,
            autoSize: true,
            aspectRatio: true,
            autoResize: true,
            helpers: {
                media: {}
            },
            beforeLoad: function() {
                var url = $this.attr('href');
                url = url.replace(new RegExp('watch\\?v=', 'i'), 'v/');
                url += '?fs=1&autoplay=1';
                this.href = url;
            }
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/fancybox/fancybox.js